import { useNavigate } from 'react-router-dom'
import { Table, Input } from 'reactstrap'
import { enterKeyHandler } from '../../../utils'
import useForm from '../../CustomHooks/FormHook'
import '../Custom.css'
import { initialFormValues, submitFormValues } from '../CustomUtils'
import DateRangeInput from '../DateRangeInput'
import FormHeading from '../FormHeading'
import FormSubmitButton from '../FormSubmitButton'

export default function AverageDefenseCostForm({ location }) {
  console.log('AverageDefenseCostForm rendered: ', location)

  let init = {
    dateFrom: '',
    dateTo: '',
    closed: '',
    reclosed: '',
    pending: '',
    abandoned: '',
    lung: 'on',
    meso: 'on',
    other: 'on',
  }

  const navigate = useNavigate()
  init = initialFormValues('AverageDefenseCostForm', navigate, init)
  const { inputs, handleInputChange, handleSubmit } = useForm(init, submitSearch, enterKeyHandler(submitSearch))

  async function submitSearch() {
    console.log('AverageDefenseCostForm.submitSearch', inputs)
    inputs.closed = (inputs.closed === 'on' || inputs.closed === 'Y') ? 'Y' : ''
    inputs.reclosed = (inputs.reclosed === 'on' || inputs.reclosed === 'Y') ? 'Y' : ''
    inputs.pending = (inputs.pending === 'on' || inputs.pending === 'Y') ? 'Y' : ''
    inputs.abandoned = (inputs.abandoned === 'on' || inputs.abandoned === 'Y') ? 'Y' : ''
    inputs.lung = (inputs.lung === 'on' || inputs.lung === 'Y') ? 'Y' : ''
    inputs.meso = (inputs.meso === 'on' || inputs.meso === 'Y') ? 'Y' : ''
    inputs.other = (inputs.other === 'on' || inputs.other === 'Y') ? 'Y' : ''
    submitFormValues('AverageDefenseCostForm', navigate, inputs, 'cost.average_cost')
  }

  return (
    <div className="custom-scroll">
      <form className="form" onSubmit={handleSubmit} style={{ maxWidth: '700px', margin: '20px auto' }}>
        <div>
          <Table bordered className="custom-table custom-form-table" style={{backgroundColor: 'white'}}>
            <FormHeading headingText='Calendar Activity Report' />
            <tbody>
              <DateRangeInput label='Date range' name='date' handleInputChange={handleInputChange} defaultValueFrom={inputs.dateFrom} defaultValueTo={inputs.dateTo} />
              <tr>
                <td><b>Include</b></td>
                <td> 
                  <Input className="custom-checkbox" type="checkbox" name="closed" onChange={handleInputChange} style={{marginLeft: '5px'}} defaultChecked={inputs.closed} /> Date Closed 
                  <Input className="custom-checkbox" type="checkbox" name="reclosed" onChange={handleInputChange} style={{marginLeft: '20px'}} defaultChecked={inputs.reclosed} /> Date Re-closed 
                  <Input className="custom-checkbox" type="checkbox" name="pending" onChange={handleInputChange} style={{marginLeft: '20px'}} defaultChecked={inputs.pending} /> Date Moved to Pending 
                  <Input className="custom-checkbox" type="checkbox" name="abandoned" onChange={handleInputChange} style={{marginLeft: '20px'}} defaultChecked={inputs.abandoned} /> Date Moved to Abandoned 
                </td>
              </tr>
              <tr>
                <td><b>Diagnosis</b></td>
                <td> 
                  <Input className="custom-checkbox" type="checkbox" name="lung" onChange={handleInputChange} style={{marginLeft: '5px'}} defaultChecked={inputs.lung} /> Lung Cancer
                  <Input className="custom-checkbox" type="checkbox" name="meso" defaultChecked={inputs.meso} onChange={handleInputChange} style={{marginLeft: '20px'}} /> Mesothelioma
                  <Input className="custom-checkbox" type="checkbox" name="other" defaultChecked={inputs.other} onChange={handleInputChange} style={{marginLeft: '20px'}}/> Other
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
        <FormSubmitButton />
      </form>
    </div>
  )
}
